export const getCoinRouteData = async (id: string) => {
	try {
		const res = await fetch(`/api/coin-data/coin-route-data?id=${id}`);
		return await res.json();
	} catch (e) {
		console.log('error occurred', e);
	}
};
